import './App.css';

const iconSrc = {
  whatsapp: '/img/whatsapp.png',
  telegram: '/img/telegram.png',
  facebook: '/img/facebook.png',
  instagram: '/img/instagram.png',
  tiktok: '/img/tik-tok.png',
  youtube: '/img/youtube.png',
  gplay: '/img/google-play.png',
  appstore: '/img/apple-logo.png',
  web: '/img/Syria Sales-02.png',
};

const socialLinks = [
  { name: 'WhatsApp', href: 'https://api.whatsapp.com/send/?phone=%2B963944455554&text&type=phone_number&app_absent=0', icon: 'whatsapp' },
  { name: 'Instagram', href: 'https://www.instagram.com/syria.sales?igsh=MWlrN2VseGoxaDh2eA==', icon: 'instagram' },
  { name: 'Facebook', href: 'https://www.facebook.com/SyriaSales.ads', icon: 'facebook' },
  { name: 'TikTok', href: 'https://www.tiktok.com/@syriasales', icon: 'tiktok' },
  { name: 'Telegram', href: 'http://t.me/SyriaSales', icon: 'telegram' },
  { name: 'YouTube', href: 'https://www.youtube.com/@SyriaSales', icon: 'youtube' },
  { name: 'Google Play', href: 'https://play.google.com/store/apps/details?id=com.perlatech.syriasales', icon: 'gplay' },
  { name: 'App Store', href: 'https://apps.apple.com/us/app/s-sales/id6751532637', icon: 'appstore' },
  { name: 'الموقع الرسمي للشركة', href: 'https://syriasales.com/', icon: 'web', isSite: true },
];

function App() {
  return (
    <div className="app-shell">
      <nav className="topbar">
        <div className="brand">
          <div className="brand-mark">
            <img src="/img/Syria Sales-04.png" alt="Syria Sales logo" />
          </div>
          <div className="brand-text">
            <span className="brand-name">Syria Sales</span>
            <span className="brand-tagline">Online Market</span>
          </div>
        </div>
        <a className="contact-btn" href="#contact">
          تواصل معنا
        </a>
      </nav>

      <main className="page">
        <section className="hero" id="home">
          <div className="hero-media">
            <img src="/img/Syria Sales-04.png" alt="Syria Sales logo" />
          </div>
          <div className="hero-copy">
            <p className="eyebrow">السوق كلو بتطبيق واحد</p>
            <h2>
              ابحث عن أي منتج أو خدمة من جميع الشركات في مكان واحد <span role="img" aria-label="بحث">🔍</span>
            </h2>
            <p className="lede">تصفح كل المنصات من هنا أو انتقل مباشرة إلى موقعنا الرسمي.</p>
            <div className="icon-strip" aria-label="روابط المنصات">
              {socialLinks.map((item) =>
                item.isSite ? (
                  <a key={item.href} className="icon-chip site-chip" href={item.href} target="_blank" rel="noreferrer">
                    <span className="chip-icon" aria-hidden="true">
                      <img src={iconSrc[item.icon]} alt="شعار الموقع الرسمي" />
                    </span>
                    <span className="site-label">{item.name}</span>
                  </a>
                ) : (
                  <a
                    key={item.href}
                    className="icon-chip"
                    href={item.href}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={item.name}
                  >
                    <span className="chip-icon" aria-hidden="true">
                      <img src={iconSrc[item.icon]} alt={item.name} />
                    </span>
                    <span className="sr-only">{item.name}</span>
                  </a>
                ),
              )}
            </div>
          </div>
        </section>
      </main>

      <footer className="footer" id="contact">
        <div className="footer-col" id="about">
          <h3>من نحن</h3>
          <p>Syria Sales منصة تجارة إلكترونية بسيطة بصفحة واحدة، تربط العملاء بأهم منتجاتنا وخدماتنا مباشرة.</p>
        </div>
        <div className="footer-col">
          <h3>معلومات التواصل</h3>
          <ul>
    <li>الهاتف : 963944455554+</li>
            <li>البريد : info@syriasales.com</li>
            <li>الرقم الرباعي : 0117068</li>
          </ul>
        </div>
        <div className="footer-col">
          <h3>العنوان</h3>
<p> العنوان :
أول طلعة العفيف - بناء بن الحموي - طابق 3</p>       
</div>
      </footer>
    </div>
  );
}

export default App;
